module.exports = __webpack_public_path__ + "img/soul-icon.fbabf297.png";